var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantages6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 4.16663L12.5 20.8333V45.8333C12.5 68.9583 28.5 90.5833 50 95.8333C71.5 90.5833 87.5 68.9583 87.5 45.8333V20.8333L50 4.16663ZM50 29.1666C55.8333 29.1666 61.6667 33.75 61.6667 39.5833V45.8333C64.1667 45.8333 66.6667 48.3333 66.6667 51.25V65.8333C66.6667 68.3333 64.1667 70.8333 61.25 70.8333H38.3333C35.8333 70.8333 33.3333 68.3333 33.3333 65.4166V50.8333C33.3333 48.3333 35.8333 45.8333 38.3333 45.8333V39.5833C38.3333 33.75 44.1667 29.1666 50 29.1666ZM50 34.1666C46.6667 34.1666 43.75 36.25 43.75 39.5833V45.8333H56.25V39.5833C56.25 36.25 53.3333 34.1666 50 34.1666Z",
    fill: "url(#paint0_linear_231_970)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_970",
    x1: 6.5674,
    y1: 105.51,
    x2: 104.697,
    y2: 19.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantages6);
export default __webpack_public_path__ + "static/media/advantages_6.236cc2d81aca28c2524b1edced83a925.svg";
export { ForwardRef as ReactComponent };